import axios from 'axios';
import apiConfig from '../config/apiConfig';

const API_BASE_URL = apiConfig.BASE_URL;

// Get all categories (multilingual support)
export const getAllCategories = async (params = {}) => {
  try {
    const { lang, region } = params;
    const queryParams = new URLSearchParams();
    if (lang) queryParams.append('lang', lang);
    if (region) queryParams.append('region', region);
    
    const url = queryParams.toString() 
      ? `${API_BASE_URL}/categories?${queryParams.toString()}`
      : `${API_BASE_URL}/categories`;
    
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

// Get popular categories (multilingual support)
export const getPopularCategories = async (limit = 4, params = {}) => {
  try {
    const { lang, region } = params;
    const queryParams = new URLSearchParams();
    queryParams.append('limit', limit);
    if (lang) queryParams.append('lang', lang);
    if (region) queryParams.append('region', region);
    
    const response = await axios.get(`${API_BASE_URL}/categories/popular?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching popular categories:', error);
    throw error;
  }
};

// Get category by slug (multilingual support with region)
export const getCategoryBySlug = async (slug, lang = null, region = null) => {
  try {
    const params = {};
    if (lang) params.lang = lang;
    if (region) params.region = region;
    const response = await axios.get(`${API_BASE_URL}/categories/${slug}`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching category by slug:', error);
    throw error;
  }
};

// Get articles by category (multilingual support)
export const getCategoryArticles = async (slug, params = {}) => {
  try {
    const { page = 1, limit = 10, lang, region } = params;
    const queryParams = new URLSearchParams();
    
    if (page) queryParams.append('page', page);
    if (limit) queryParams.append('limit', limit);
    if (lang) queryParams.append('lang', lang);
    if (region) queryParams.append('region', region);
    
    const response = await axios.get(`${API_BASE_URL}/categories/${slug}/articles?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching category articles:', error);
    throw error;
  }
};

// Create category (Admin only)
export const createCategory = async (categoryData) => {
  try {
    const token = getAuthToken();
    const response = await axios.post(`${API_BASE_URL}/categories`, categoryData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating category:', error);
    throw error;
  }
};

// Update category (Admin only)
export const updateCategory = async (id, categoryData) => {
  try {
    const token = getAuthToken();
    const response = await axios.put(`${API_BASE_URL}/categories/${id}`, categoryData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating category:', error);
    throw error;
  }
};

// Delete category (Admin only)
export const deleteCategory = async (id) => {
  try {
    const token = getAuthToken();
    const response = await axios.delete(`${API_BASE_URL}/categories/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
};

// Helper function to get auth token
const getAuthToken = () => {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (persistRoot) {
      const parsed = JSON.parse(persistRoot);
      if (parsed.auth) {
        const authState = JSON.parse(parsed.auth);
        return authState.token;
      }
    }
  } catch (e) {
    console.warn('Could not read token from redux-persist:', e);
  }
  
  return localStorage.getItem('token') || sessionStorage.getItem('token');
};


